import React, { useState, useEffect } from "react";
import { Card, CardBody, CardTitle, Row, Collapse, Table } from "reactstrap";
import { Helmet } from "react-helmet-async";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// service e utils
import {
  deleteProfile,
  getProfiles,
} from "../../utils/services/profilesScreen";
import useDebounce from "../../utils/hooks/useDebounce";
// compontens
import SectionComponent from "../Apps/Personalization/SectionComponent";
import ActionButtonRounded from "../../components/Buttons/ActionButtonRounded";
import LoadingSkelentonTable from "../../components/loadingSkeletonTable";
import DeleteButton from "../../components/Buttons/DeleteButton";
import ModalNewProfile from "./create/ModalNewProfile";
import ModalEditProfile from "./edit/ModalEditProfile";
import Pagination from "../../components/Paginationv3";

export default function Profiles() {
  const [isOpen, setIsOpen] = useState(false);
  // modal
  const [modalNewProfile, setModalNewProfile] = useState(false);
  const [modalEditProfile, setModalEditProfile] = useState(false);
  // perfil selecionado para ação
  const [profileSelected, setProfileSelected] = useState(null);
  // alerta
  const [deleteItem, setDeleteItem] = useState(false);
  const [deleteItemConfirmed, setDeleteItemConfirmed] = useState(false);
  // listagem
  const [profilesList, setProfilesList] = useState([]);
  // paginação
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 300);
  const [currentIndex, setCurrentIndex] = useState(1);
  const [countData, setCountData] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // loading
  const [isLoading, setIsLoading] = useState(false);
  const [alertError, setAlertError] = useState(false);
  const [messageAlertError, setMessageAlertError] = useState("");
  const [loadingDelete, setLoadingDelete] = useState(false);

  function getProfilesList() {
    setIsLoading(true);
    getProfiles({
      offset: currentIndex,
      limit: itemsPerPage,
      search: debouncedSearch,
      columnSearch: "description",
    })
      .then((res) => {
        if (res.message === "PROFILES") {
          setProfilesList(res.data.profiles);
          setCountData(res.data.total);
        } else {
          setProfilesList([]);
          setCountData(0);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("erro", error);
        setIsLoading(false);
      });
  }

  async function deleteProfiles() {
    const res = await deleteProfile(profileSelected.id);

    if (res.message === "PROFILE_DELETED") {
      setDeleteItemConfirmed(true);
    }
    if (res.data.message === "HAS_LINKED_LOGIN") {
      setAlertError(true);
      setMessageAlertError(
        `Não foi possível excluir o perfil ${profileSelected.description}, existem usuários vinculados a ele.`,
      );
    }
    if (
      res.data.message === "VALIDATION_ERROR" ||
      res.data.message === "PROFILE_NOT_FOUND"
    ) {
      setAlertError(true);
      setMessageAlertError(
        `Não foi possível excluir o perfil ${profileSelected.description}, dados inválidos.`,
      );
    }
  }

  useEffect(() => {
    getProfilesList();
  }, [currentIndex, itemsPerPage, debouncedSearch]);

  return (
    <>
      {alertError && (
        <SweetAlert
          danger
          title={"Erro"}
          onConfirm={() => {
            setAlertError(false);
          }}
        >
          {messageAlertError}
        </SweetAlert>
      )}
      {modalNewProfile && (
        <ModalNewProfile
          isOpen={modalNewProfile}
          toggle={() => setModalNewProfile(false)}
          getProfilesList={getProfilesList}
        />
      )}

      {modalEditProfile && (
        <ModalEditProfile
          isOpen={modalEditProfile}
          toggle={() => setModalEditProfile(false)}
          profileSelected={profileSelected}
          getProfilesList={getProfilesList}
        />
      )}

      {deleteItem && (
        <SweetAlert
          title={
            loadingDelete
              ? `Deletando perfil ${profileSelected.description}...`
              : `Deseja deletar o Perfil ${profileSelected.description}?`
          }
          warning
          showCancel={!loadingDelete}
          confirmBtnText={loadingDelete ? "Aguarde..." : "Sim"}
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          showConfirm={!loadingDelete}
          onConfirm={async () => {
            setLoadingDelete(true);
            try {
              await deleteProfiles();
            } finally {
              setDeleteItem(false);
              setLoadingDelete(false);
            }
          }}
          onCancel={() => setDeleteItem(false)}
        >
          {loadingDelete
            ? "Processando..."
            : "Você não poderá reverter essa ação."}
        </SweetAlert>
      )}

      {deleteItemConfirmed && (
        <SweetAlert
          success
          title="Sucesso"
          onConfirm={() => {
            getProfilesList();
            setDeleteItemConfirmed(false);
          }}
        >
          Perfil deletado com sucesso
        </SweetAlert>
      )}

      <Helmet>Perfis | Inteegra Plus</Helmet>
      <Card>
        <CardBody>
          <CardTitle>Perfis</CardTitle>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  value={search}
                  type="text"
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>

            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type="text"
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>

              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />

              <Collapse isOpen={isOpen}>
                <ActionButtonRounded
                  title="Adicionar Perfil"
                  onClick={() => setModalNewProfile(true)}
                  type="mobile"
                />
              </Collapse>
            </div>

            <div className="header-btns-container">
              <ActionButtonRounded
                title="Adicionar Perfil"
                onClick={() => setModalNewProfile(true)}
              />
            </div>
          </div>

          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>Nome</th>
                  <th>Visualizar Todos Eventos</th>
                  <th>Ações</th>
                </tr>
              </thead>

              <tbody>
                {isLoading ? (
                  <LoadingSkelentonTable lines={10} cols={4} />
                ) : profilesList &&
                  profilesList.length > 0 &&
                  profilesList
                    .filter((obj) => !obj.isDefault)
                    .map((e, i) => (
                      <tr key={i}>
                        <td>{e.id}</td>
                        <td>{e.description}</td>
                        <td>{e.showAllEvents ? "Sim" : "Não"}</td>
                        <td>
                          <i
                            className="mdi mdi-pencil"
                            style={{
                              color: "green",
                              fontSize: 17,
                              cursor: "pointer",
                              marginRight: 5,
                            }}
                            onClick={() =>
                              setProfileSelected(e) > setModalEditProfile(true)
                            }
                          />
                          <DeleteButton
                            onClick={() =>
                              setProfileSelected(e) > setDeleteItem(true)
                            }
                          />
                        </td>
                      </tr>
                    ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
      <div
        className="bottom-navigation"
        style={{
          justifyContent: "end",
        }}
      >
        <Pagination
          data={profilesList}
          search={search}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={countData}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </>
  );
}
